import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideOidcClient } from '@upmc-healthplan-npm/oidc-client';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './shared/shared.module';
import { AssessmentsModule } from './modules/assessments/assessments.module';
import { NgIdleModule } from '@ng-idle/core';
import { httpInterceptorProviders } from './interceptors';
import { API_CONFIG } from './api-config/api-config';
import { resolveApiConfig, resolveOAuthConfig } from './shared/utils/environment-resolver';
import { routes } from './app.routes';
import { provideRouter, withHashLocation } from '@angular/router';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule, SharedModule, AssessmentsModule, NgIdleModule.forRoot()),
    httpInterceptorProviders,
    {
      provide: API_CONFIG,
      useFactory: resolveApiConfig,
    },
    provideOidcClient(resolveOAuthConfig),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(routes, withHashLocation()),
  ],
};
